//
//
//
//
//
//
//
//
//

export default {
    props: ['src', 'poster'],
    data() {
        return {
            isPlay: false,
            duration: 0,
            currentTime: 0
        }
    },
    computed: {
        process() {
            return parseInt(this.currentTime * 100 / this.duration);
        }
    },
    methods: {
        playVideo() {
            var thisVideo = document.getElementById('thisVideo');
            this.isPlay = true;
            thisVideo.play();
        },
        pauseVideo() {
            var thisVideo = document.getElementById('thisVideo');
            this.isPlay = false;
            thisVideo.pause();
        }
    },
    mounted() {
        let that = this;
        var thisVideo = document.getElementById('thisVideo');
        thisVideo.addEventListener('ended', function(e) {
            that.isPlay = false;
        })
        thisVideo.addEventListener('durationchange', function(e) {
            that.duration = thisVideo.duration;
        })
        thisVideo.addEventListener('timeupdate', function(e) {
            that.currentTime = thisVideo.currentTime;
        })
    }
}



// WEBPACK FOOTER //
// ./src/components/common/stVideo.vue